import React from 'react';

function AccountInfoTab() {
  return (
    <div className="AccountInfoTab">
    </div>
  );
}

export default AccountInfoTab;